import axios from 'axios';
// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { timer } from 'rxjs/observable/timer';
import { debounce } from 'rxjs/operators/debounce';
import { Subject } from 'rxjs/Subject';
import { Environment } from '../../environment/environment';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';
import './iri.scss';

const _Select = Select as any;
// https://github.com/JedWatson/react-select

export interface IriFieldProps {
    className?: string;
    title?: string;
    placeholder?: string;
    property?: string;
    field: Field;
    multi?: boolean;
    defaultValue?: string;
    defaultAll?: boolean;
    validators?: Validator[];
    itemRender?: (iri: any) => any;
    disabled?: boolean;
    onFetched?: (field: Field) => void;
    onChange?: (value: any) => void;
    forceQuery?: any;
}

export class IriField extends BaseField<IriFieldProps> {
    public field: Field = this.props.field;
    public state: any = {
        value: null,
        options: [],
        isLoading: false,
        disabled: this.field.disabled
    };
    public onSearchKey$: Subject<any> = new Subject();

    async componentDidMount() {
        this.field.registerField();

        this.field.onValueChanges$.subscribe(async (value) => {
            if (Array.isArray(value)) {
                const fetched = await Promise.all(value.map(async (item: any) => {
                    return await this.getByIri(this.toIri(item));
                }));

                this.field.setValue(this.parseIri(this.parseValue(fetched)), true, false);

                if (this.props.onChange) {
                    this.props.onChange(this.parseIri(this.parseValue(fetched)));
                }

                this.setViewValue(this.parseValue(fetched));

            } else {
                try {
                    if (value !== null) {
                        this.field.setValue(this.parseIri(this.parseValue(value)), true, false);

                        if (this.props.onChange) {
                            this.props.onChange(this.parseIri(this.parseValue(value)));
                        }

                        this.setViewValue(this.parseValue(await this.getByIri(this.toIri(value))));
                    }
                } catch (err) {
                    console.warn('IRI FAIL', err);
                }
            }


            this.field.onValidate$.next();
        });

        this.onSearchKey$.pipe(debounce(() => timer(500))).subscribe(async (value) => {
            this.setState({
                options: await this.searchAndTransformResult(value)
            });
        });

        if (this.props.defaultAll) {
            this.onSearchKey$.next('');
        }

        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        if (typeof this.props.disabled !== 'undefined') {
            this.field.disabled = this.props.disabled;
            this.setState({disabled: this.field.disabled});
        }

        if (this.field.value && this.field.registered) {
            this.field.onValueChanges$.next(this.field.value);
        }

        this.field.onDisableChanges$.subscribe((value: boolean) => {
            this.setState({disabled: value});
            this.field.disabled = value;
        });

        if (this.props.defaultValue) {
            const value = this.props.defaultValue;
            this.field.setValue(this.parseIri(this.parseValue(value)), true, false);
            this.setViewValue(this.parseValue(await this.getByIri(this.toIri(value))));

            if (this.props.onChange) {
                this.props.onChange(this.parseIri(this.parseValue(value)));
            }
        }

    }

    componentDidUpdate(prevProps: any, prevState: any){
        if (JSON.stringify(prevProps.forceQuery) !== JSON.stringify(this.props.forceQuery)){
            this.onSearchKey$.next('')
        }
    }


    public async searchAndTransformResult(keyword: string) {
        this.setIsLoading(true);
        let params: any = {
            _keyword: keyword,
            pagination: false
        };

        if (!keyword) {
            delete params._keyword;
        }

        if (this.props.forceQuery) {
           params = Object.assign(params, this.props.forceQuery);
        }

        try {
            const fetched = await axios.get(`${Environment.get('api.base')}/${this.field.iri}`, {
                params: params,
                withCredentials: true
            });

            this.setIsLoading(false);

            if (fetched.data && fetched.data['hydra:member']) {
                this.emitFetched();
                return Promise.resolve((fetched.data['hydra:member'] || []).map((i: any) => this.parseValue(i)));
            }
        } catch (err) {
            this.setIsLoading(false);
            return Promise.resolve([]);
        }
    }

    public setViewValue(value: any) {
        this.setState({
            value: value
        });
    }

    public onValueChange(event: any) {
        this.setViewValue(event);
        this.field.setValue(this.parseIri(event), false, false);
        this.field.onValidate$.next();

        if (this.props.onChange) {
            this.props.onChange(this.parseIri(event));
        }
    }

    render() {
        return (
            <div className={this.props.className} id={this.uid}>
                <div className="form-group">
                    <label htmlFor={this.uid + '_input'}>{this.props.title || this.field.title}</label>
                    <div className={'input-group' + (this.state.disabled && ' disabled')}>
                        <_Select
                            className="iri-error-fixer"
                            value={this.state.value}
                            onChange={(event: any) => this.onValueChange(event)}
                            options={this.state.options}
                            isLoading={this.state.isLoading}
                            onInputChange={(event: any) => this.onSearchKey$.next(event)}
                            multi={(typeof this.props.multi === 'undefined') ? this.field.multi : this.props.multi}
                            disabled={this.state.disabled}
                        />
                        <ValidatorComponent field={this.field}/>
                    </div>
                </div>
            </div>
        );
    }

    public emitFetched() {
        if (this.props.onFetched) {
            this.props.onFetched(this.field);
        }
    }

    private async getByIri(iri: string) {
        this.setIsLoading(true);
        try {
            const fetched = await axios.get(`${Environment.get('api.base')}${iri}`, {withCredentials: true});
            this.setIsLoading(false);
            if (fetched.data) {
                return Promise.resolve(fetched.data);
            } else {
                return Promise.reject('no.item');
            }
        } catch (err) {
            this.setIsLoading(false);
            return Promise.reject(err.message);
        }
    }

    private parseIri(value: any) {
        if (Array.isArray(value)) {
            return value.map((i: any) => this.toIri(i.value));
        } else {
            return this.toIri((value || {}).value || null);
        }
    }

    private toIri(raw: any) {
        if (get(raw, '@id')) {
            return get(raw, '@id');
        } else if (get(raw, 'id')) {
            return `/${this.field.iri}/${get(raw, 'id')}`;
        } else {
            return raw;
        }
    }

    private parseValue(value: any) {
        if (Array.isArray(value)) {
            return value.map((i: any) => this.toValue(i));
        } else {
            return this.toValue(value);
        }
    }

    private toValue(rawItem: any) {
        return {
            label: this.props.itemRender ? (this.props.itemRender(rawItem)) : (rawItem.title || 'NO_LABEL'),
            value: this.toIri(rawItem)
        };
    }

    private setIsLoading(bool: boolean) {
        this.setState({
            isLoading: bool
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/iri.field.tsx